export default function getImage(imagePath)
{
    imagePath = imagePath.trim("/")
    if (window.location.origin === "http://localhost:3000") {
        return "http://localhost/django_media/" + imagePath ;
    } else {
        return window.location.origin+"/django_media/"+imagePath;
    }
    }